import React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import Dash from "../images/dashboardIcon.svg";
import dashArrow from "../images/dashArrow.svg";

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 40px;
  background: #1473e6;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  &.hidden {
    bottom: 0;
  }
  transition: bottom 1s;
`;

const Label = styled.label`
  font-family: "Inter";
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.138889px;
  color: #ffffff;
  cursor: pointer;
`;

const DashIcon = styled.img`
  height: 16px;
  width: 16px;
  margin: 0 12px;
  cursor: pointer;
`;
const Wrap = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const AdminUrl = process.env.REACT_APP_IMAGE_BASE_URL;

export default function AdminFooter() {
  const content = (
    <Wrapper>
      <Wrap
        onClick={() => {
          window.open(AdminUrl, "_blank");
        }}
      >
        <DashIcon src={Dash} alt="dashboard" />
        <Label>Manage Help Center</Label>
        <DashIcon src={dashArrow} alt="arrow" />
      </Wrap>
    </Wrapper>
  );
  return createPortal(content, document.body);
}
